import { ELandStatusType } from '../../../../JsonQuery';

export const LAND_STATUSES_MAP_VALUE_TO_LABEL = {
  [ELandStatusType.Farm]: 'Фермерское хозяйство',
  [ELandStatusType.PrivateFarm]: 'Личное подсобное хозяйство',
  [ELandStatusType.Gardening]: 'Садоводство',
  [ELandStatusType.IndustrialLand]: 'Земля промназначения',
  [ELandStatusType.InvestmentProject]: 'Инвестпроект',
  [ELandStatusType.IndividualHousingConstruction]: 'ИЖС',
  [ELandStatusType.CountryhouseNonCommercialPartnership]: 'ДНП',
};
